var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreaterThanEqual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M440 439.998H8C3.594 439.998 0 443.592 0 447.999S3.594 456 8 456H440C444.406 456 448 452.406 448 447.999S444.406 439.998 440 439.998ZM56.562 322.952C57.812 326.078 60.812 327.984 64 327.984C65 327.984 65.999 327.797 66.969 327.422L386.969 199.406C389.999 198.187 392 195.249 392 191.968C392 188.686 389.999 185.748 386.969 184.529L66.969 56.514C62.938 55.013 58.219 56.889 56.562 60.983C54.938 65.077 56.938 69.734 61.031 71.39L362.469 191.968L61.031 312.545C56.938 314.201 54.938 318.858 56.562 322.952Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreaterThanEqual);
export default __webpack_public_path__ + "static/media/greater-than-equal.b4aa0999d63304a9b00886383e29e9c6.svg";
export { ForwardRef as ReactComponent };